import React, { Component } from 'react';
import moment from 'moment';
import TimeAgo from 'react-timeago'
import {Link} from 'react-router-dom'
import ReactImageMagnify from 'react-image-magnify';

export default class Row extends Component{  
  renderLocation(){
    if(this.props.data.Location !== null){
      return this.props.data.LocationName
    }
    return null
  }

  renderImgMobile() {
    if (this.props.data.AssetImage !== null) {
      return (
        <div className="card-img-timeline">
          <img src={this.props.data.AssetImage+"&token="+this.props.UserReducer.token} alt={this.props.data.AssetName}/>
        </div>
      )
    } else {
      return null
    }
  }

  renderTimelineMobile() {
    return (
      <div className="card">
        {this.renderImgMobile()}
        <div className="card-body">
          <h5 className="card-title">
            <b>{this.props.data.AssetName}</b> {"("+this.props.data.Asset+")"}
          </h5>
          <h6 className="card-subtitle mb-2 text-muted">
            {this.props.data.UserFullName} &middot; <TimeAgo date={this.props.data.ChekinTime} />
          </h6>
          <p className="card-text">
            Check-in&nbsp;
            <strong className="record-changed-new">
              <Link className="word-break" to={"/admin/master-asset-details-" + this.props.data.Asset + "/"}>
                {this.props.data.AssetName+" ("+this.props.data.Asset+") "}
              </Link>
            </strong>
            into site:&nbsp;<b>{this.props.data.SiteName}</b>&nbsp;
            in location:&nbsp;<b>{this.renderLocation()}</b>
          </p>
        </div>
      </div>
    )
  }

  renderTimeline() {
    if(this.props.data.AssetImage !== null){
      return(
        <div className="entry">
          <div className="title col-sm-3 col-md-3 col-lg-3">
            <h3>
              <strong>{this.props.data.UserFullName}</strong>
            </h3>
            <p>
              <strong>
                {this.props.data.ChekinTime !== null ? moment(this.props.data.ChekinTime).format('YYYY-MM-DD h:mm:ss a'):"-"}
              </strong>
              <br/>(<TimeAgo date={this.props.data.ChekinTime} />)
            </p>
          </div>
          <div className="body col-sm-9 col-md-9 col-lg-9">
            <p>
              <b>{this.props.data.AssetName}</b> {"("+this.props.data.Asset+")"}
            </p>
            <ul>
              <li>
              <div className="row">
                <div className="col-md-4">
                  <ReactImageMagnify {...{
                      smallImage: {
                          alt: this.props.data.AssetName,
                          isFluidWidth: true,
                          src: this.props.data.AssetImage+"&token="+this.props.UserReducer.token,
                          width: 300,
                          height: 450
                      },
                      largeImage: {
                          src: this.props.data.AssetImage+"&token="+this.props.UserReducer.token,
                          width: 1200,
                          height: 1800
                      },
                      enlargedImageContainerDimensions: {
                          width: '200%',
                          height: '100%'
                      },
                      enlargedImageContainerClassName: "z99",
                      enlargedImageClassName: "z99",
                      className:"img-responsive-for-activities",
                      isHintEnabled: true,
                    }}
                  />
                </div>
                <div className="col-md-8">
                  <div className="row">
                    <strong className="record-changed-old">{this.props.data.User}</strong>
                    &nbsp;Check-in&nbsp;
                    <strong className="record-changed-new">
                      <a className="word-break" href={"/admin/master-asset-details-" + this.props.data.Asset + "/"} >{this.props.data.AssetName+" ("+this.props.data.Asset+") "}</a>&nbsp;
                    </strong>
                    into site:&nbsp;<b>{this.props.data.SiteName}</b>&nbsp;
                    in location:&nbsp;<b>{this.renderLocation()}</b>
                  </div>
                </div>
              </div>
              </li>
            </ul>
          </div>
        </div>
      )
    }else{
      return(
        <div className="entry">
          <div className="title col-sm-3 col-md-3 col-lg-3">
            <h3>
              <strong>{this.props.data.UserFullName}</strong>
            </h3>
            <p>
              <strong>{this.props.data.ChekinTime !== null ? moment(this.props.data.ChekinTime).format('YYYY-MM-DD h:mm:ss a'):"-"}</strong>
              <br/>(<TimeAgo date={this.props.data.ChekinTime} />)
            </p>
          </div>
          <div className="body col-sm-9 col-md-9 col-lg-9">
            <p><b>{this.props.data.AssetName}</b> {" ("+this.props.data.Asset+")"}</p>
            <ul>
              <li>
              <div className="row">
                <strong className="record-changed-old">{this.props.data.User}</strong>
                &nbsp;Check-in&nbsp;
                <strong className="record-changed-new">
                  <a href={"/admin/master-asset-details-"+this.props.data.Asset+"/"}>{this.props.data.AssetName+" ("+this.props.data.Asset+") "}</a>&nbsp;
                </strong>
                into site:&nbsp;<b>{this.props.data.SiteName}</b>&nbsp;
                in location:&nbsp;<b>{this.renderLocation()}</b>
              </div>
              </li>
            </ul>
          </div>
        </div>
      )
    }
  }
  
  render(){
    const {width} = this.props;
    if(width <= 768) {
      return this.renderTimelineMobile()
    } else {
      return this.renderTimeline()
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/home/helper/row.js